import { cn } from '@/lib/utils';
import { ContentProps, ContentVariant } from './types';

const variantClassNames: Record<ContentVariant, string> = {
  face: 'max-w-7xl',
  flow: 'max-w-3xl'
};

const Content = (props: ContentProps) => {
  const {
    children,
    className,
    variant
  } = props;

  return (
    <div className={cn('mx-auto w-full px-4 min-[769px]:px-8', variantClassNames[variant], className)}>
      {children}
    </div>
  );
};

export default Content;